import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import VendorsPageTitle from 'vendors/components/VendorsPageTitle'
import { useTranslation } from 'react-i18next'

const WorkRegionHeader = () => {
  const { t } = useTranslation()
  return (
    <Box sx={{ width: '100%', maxWidth: '650px' }}>
      <VendorsPageTitle>{t('select-region-of-operation')}</VendorsPageTitle>
      <Typography variant="body2" sx={{ mt: 1 }}>
        {t('select-region-of-operation-helper-text')}
      </Typography>
    </Box>
  )
}

export default WorkRegionHeader
